import { render, staticRenderFns } from "./design.vue?vue&type=template&id=6857497b&scoped=true"
import script from "./design.vue?vue&type=script&lang=js"
export * from "./design.vue?vue&type=script&lang=js"
import style0 from "./design.vue?vue&type=style&index=0&id=6857497b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6857497b",
  null
  
)

export default component.exports